<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="openAddModal">新增菜单</a-button>
      <a-button icon="reload" style="margin-left: 8px" @click="loadMenuTree">刷新</a-button>
    </div>
    <a-table
      :columns="columns"
      :dataSource="menuTree"
      :loading="loading"
      rowKey="id"
      :pagination="false"
      :defaultExpandAllRows="true"
      :scroll="{x:1300,y:500}"
      :childrenColumnName="'children'"
    >
      <span slot="status" slot-scope="text, record">
        <a-switch :checked="record.status === 1" :loading="record && record.statusLoading || false" @change="onStatusChange(record, $event)" />
      </span>
      <span slot="type" slot-scope="text">
        <a-tag :color="text === 1 ? 'blue' : 'green'">{{ text === 1 ? '菜单' : '按钮' }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="openEditModal(record)" class="edit-ico" style="margin-right:10px;">编辑</a>
        <a-popconfirm title="确定要删除该菜单吗？" @confirm="handleDelete(record)">
          <a class="delete-ico">删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <a-modal
      :title="modalTitle"
      v-model="modalVisible"
      @ok="handleOk"
      :confirmLoading="modalLoading"
      destroyOnClose
      :width="800"
    >
      <a-form :form="form" layout="horizontal">
        <a-form-item 
          label="名称" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
          :validateStatus="form.getFieldError('text') ? 'error' : ''"
          :help="form.getFieldError('text') || ''"
        >
          <a-input 
            v-decorator="[
              'text', 
              { 
                rules: [
                  { required: true, message: '请输入名称' },
                  { max: 20, message: '名称不能超过20个字符' }
                ] 
              }
            ]" 
            placeholder="请输入名称"
          />
        </a-form-item>
        
        <a-form-item 
          label="上一级菜单" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
        >
          <a-tree-select
            v-decorator="['pid', { initialValue: 0 }]"
            :treeData="treeSelectData"
            placeholder="请选择父级菜单"
            allowClear
            show-search
            treeNodeFilterProp="title"
            :filterTreeNode="filterTreeNode" 
            treeDefaultExpandAll
            :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
          />
        </a-form-item>
        
        <a-form-item 
          label="菜单类型" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
        >
         <a-button-group>
               <a-button 
                 :type="form.getFieldValue('type') === 1 ? 'primary' : 'default'"
                 @click="handleTypeChange(1)"
               >
                 菜单
               </a-button>
               <a-button 
                 :type="form.getFieldValue('type') === 0 ? 'primary' : 'default'"
                 @click="handleTypeChange(0)"
               >
                 按钮
               </a-button>
             </a-button-group>
             <a-input 
               v-decorator="['type', { initialValue: 1 }]" 
               style="display: none" 
             />
        </a-form-item>
        
        <a-form-item 
          label="链接地址" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol" 
          v-if="type === '1'"
          :validateStatus="form.getFieldError('route') ? 'error' : ''"
          :help="form.getFieldError('route') || ''"
        >
          <a-input 
            v-decorator="[
              'route',
              {
                rules: [
                  { max: 100, message: '链接地址不能超过100个字符' }
                ]
              }
            ]" 
            placeholder="请输入链接地址" 
          />
        </a-form-item>
        
        <a-form-item 
          label="路由" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol" 
          v-if="type === '1'"
          :validateStatus="form.getFieldError('url') ? 'error' : ''"
          :help="form.getFieldError('url') || ''"
        >
          <a-input 
            v-decorator="[
              'url', 
              { 
                rules: [
                  { pattern: /^\/[a-zA-Z0-9/-]*$/, message: '路由必须以/开头，只能包含字母、数字和斜杠' }
                ] 
              }
            ]" 
            placeholder="请输入路由" 
          />
        </a-form-item>
        
        <a-form-item 
          label="权限" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
          :validateStatus="form.getFieldError('prem') ? 'error' : ''"
          :help="form.getFieldError('prem') || ''"
        >
          <a-input 
            v-decorator="[
              'prem',
              {
                rules: [
                  { pattern: /^[a-zA-Z0-9:]+$/, message: '权限标识只能包含字母、数字和冒号' }
                ]
              }
            ]" 
            placeholder="请输入权限标识" 
          />
        </a-form-item>
        
        <a-form-item 
          label="排序" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
          :validateStatus="form.getFieldError('sort') ? 'error' : ''"
          :help="form.getFieldError('sort') || ''"
        >
          <a-input-number 
            v-decorator="[
              'sort', 
              { 
                initialValue: 0,
                rules: [
                  { required: true, message: '请输入排序值' },
                  { type: 'number', min: 0, max: 999, message: '排序值必须在0-999之间' }
                ]
              }
            ]" 
            :min="0" 
            :max="999"
            style="width: 100%" 
          />
        </a-form-item>
        
        <a-form-item 
          label="菜单启用状态" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-decorator="['status', { initialValue: 1 }]">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-item>
        
        <a-form-item 
          label="说明" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
          :validateStatus="form.getFieldError('tip') ? 'error' : ''"
          :help="form.getFieldError('tip') || ''"
        >
          <a-input 
            v-decorator="[
              'tip',
              {
                rules: [
                  { max: 200, message: '说明不能超过200个字符' }
                ]
              }
            ]" 
            placeholder="请输入说明" 
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import {
  getSysMenuTreeList,
  addSysMenu,
  editSysMenuById,
  deleteSysMenuById,
  getSysMenu
} from '@/api/common/api'

function convertMenuTree(list) {
  return (list || []).map(item => {
    const children = item.children && item.children.length > 0
      ? convertMenuTree(item.children)
      : item.childList && item.childList.length > 0
        ? convertMenuTree(item.childList)
        : []
    // 兼容多种父级字段名，强制补全 pid
    const pid = item.pid !== undefined ? item.pid : (item.parentId !== undefined ? item.parentId : (item.pId !== undefined ? item.pId : 0));
    return {
      ...item,
      pid,
      name: item.text,
      status: typeof item.status !== 'undefined' ? item.status : 1,
      statusLoading: false,
      children // 始终为数组
    }
  })
}

export default {
  name: 'VeBaseSysMenuList',
  data() {
    return {
      loading: false,
      menuTree: [],
      treeSelectData: [],
      type: '1', // 菜单类型，1为菜单，0为按钮
      columns: [
        { title: '名称', dataIndex: 'text', key: 'text', width: 300 },
		{ title: '菜单分类', dataIndex: 'type', key: 'type', scopedSlots: { customRender: 'type' } },
        { title: '链接地址', dataIndex: 'route', key: 'route', width: 200 },
        { title: '路由', dataIndex: 'url', key: 'url', width: 200 },
		{ title: '权限', dataIndex: 'prem', key: 'prem' },
        { title: '排序', dataIndex: 'sort', key: 'sort' },
        { title: '菜单启用状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 180, fixed: 'right' }
      ],
      modalVisible: false,
      modalTitle: '新增菜单',
      modalLoading: false,
      currentId: null,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      onFieldsChange: (props, changedFields) => {
        // 可以在这里处理字段变化
      },
      mapPropsToFields: () => {
        // 可以在这里处理初始值映射
      }
    });
  },
  created() {
    this.loadMenuTree();
  },
  methods: {
	  handleTypeChange(value) {
	        this.form.setFieldsValue({ 
	            type: value,
	            // 当切换为按钮类型时，清空路由相关字段
	            ...(value === 0 ? { 
	              route: '',
	              url: '' 
	            } : {})
	          });
	          
	          // 保持与本地状态同步
	          this.type = value.toString();
	      },
    getCurrentAppId() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return userInfo.appId || '';
      } catch (e) {
        return '';
      }
    },
    async loadMenuTree() {
      this.loading = true;
      try {
        const appId = this.getCurrentAppId();
        const res = await getSysMenuTreeList({ id: appId });
        this.menuTree = convertMenuTree(res.result || []);
        this.treeSelectData = this.buildTreeSelect(this.menuTree);
      } catch (error) {
        this.$message.error('加载菜单失败');
        console.error('加载菜单失败:', error);
      } finally {
        this.loading = false;
      }
    },
    buildTreeSelect(tree) {
      const loop = list =>
        list.map(item => ({
          title: item.text,
          value: Number(item.id),
          key: Number(item.id),
          children: item.children ? loop(item.children) : []
        }));
      // 只返回一个根节点，children为所有菜单
      return [{
        title: '顶级菜单',
        value: 0,
        key: 0,
        children: loop(tree)
      }];
    },
    filterTreeNode(inputValue, treeNode) {
      // 方法2：回退到原始数据查找
      const key = treeNode.key;
      const findNode = (tree, searchKey) => {
        for (const node of tree) {
          if (node.key === searchKey) return node;
          if (node.children) {
            const found = findNode(node.children, searchKey);
            if (found) return found;
          }
        }
        return null;
      };
      
      const originalNode = findNode(this.treeSelectData, key);
      return originalNode?.title?.includes(inputValue) || false;
    },
    openAddModal() {
      this.modalTitle = '新增菜单';
      this.currentId = null;
      this.type = '1'; // 默认选择菜单类型
      this.form.resetFields();
      this.form.setFieldsValue({ 
        pid: 0, 
        sort: 0, 
        status: 1, 
        issort: 0, 
        isdev: 0,
        type: 1
      });
	  this.handleTypeChange(1);
      this.modalVisible = true;
    },
    async openEditModal(record) {
      if (!record) {
        this.$message.error('数据异常，无法编辑！');
        return;
      }
      this.modalTitle = '编辑菜单';
      this.currentId = record.id;
      this.form.resetFields();
      this.modalVisible = true;
      // 每次都强制刷新菜单树数据，保证treeSelectData为最新
      await this.loadMenuTree();
      // 获取菜单详情并回填表单
      try {
        this.modalLoading = true;
        const res = await getSysMenu({ id: record.id });
        if (res.success && res.result) {
          const menuData = res.result;
          this.type = menuData.type === 0 ? '0' : '1'; // 设置菜单类型
          const currentId = Number(menuData.id);
          const parentId = Number(menuData.pid) < 0 ? 0 : Number(menuData.pid);
          
          this.$nextTick(() => {
            this.form.setFieldsValue({
              text: menuData.text,
              pid: parentId,
              url: menuData.url,
              route: menuData.route,
              type: menuData.type,
              prem: menuData.prem,
              issort: menuData.issort || 0,
              sort: menuData.sort || 0,
              status: menuData.status !== undefined ? menuData.status : 1,
              isdev: menuData.isdev || 0,
              tip: menuData.tip
            });
          });
        } else {
          this.$message.error('获取菜单详情失败');
        }
      } catch (error) {
        console.error('获取菜单详情失败:', error);
        this.$message.error('获取菜单详情失败');
      } finally {
        this.modalLoading = false;
      }
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if(err){
			return;
		}
        this.modalLoading = true;
        const appId = this.getCurrentAppId();
        values.appId = appId;
        values.terminalid = 0;
        // route未填写时强制为空字符串
        if (!values.route) {
          values.route = '';
        }
        // 新增菜单且选择的父菜单是顶级菜单，传pid:0
        if (!this.currentId && (values.pid === undefined || values.pid === null || values.pid === '' || values.pid === 0 || values.pid === '0')) {
          values.pid = 0;
        }
        // 编辑顶级菜单时pid=-id
        if (this.currentId && (values.pid === 0 || values.pid === '0')) {
          values.pid = -Math.abs(Number(this.currentId));
        }
        try {
          if (this.currentId) {
            await editSysMenuById({ ...values, id: this.currentId });
            this.$message.success('修改成功');
          } else {
            await addSysMenu(values);
            this.$message.success('新增成功');
          }
          this.modalVisible = false;
          this.loadMenuTree();
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error(this.currentId ? '修改失败' : '新增失败');
        } finally {
          this.modalLoading = false;
        }
      });
    },
    async handleDelete(record) {
      if (!record || !record.id) {
        this.$message.error('删除失败，未获取到菜单ID');
        return;
      }
      this.loading = true;
      try {
        await deleteSysMenuById(record);
        this.$message.success('删除成功');
        this.loadMenuTree();
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      } finally {
        this.loading = false;
      }
    },
    async onStatusChange(record, checked) {
      this.$set(record, 'statusLoading', true);
      try {
        record.status = checked ? 1 : 0;
        await editSysMenuById(record);
        this.$message.success(record.status ? '已启用' : '已禁用');
      } catch (error) {
        console.error('状态更新失败:', error);
        this.$message.error('状态更新失败');
        // 恢复原来的状态
        record.status = checked ? 0 : 1;
      } finally {
        this.$set(record, 'statusLoading', false);
      }
    }
  }
}
</script>

<style scoped>
.table-operator {
  margin-bottom: 16px;
}
.ant-form-item {
  margin-bottom: 16px;
}/* 添加调整宽度的样式 */
.ant-table-resizable {
  position: relative;
}
.ant-table-resizable-handle {
  position: absolute;
  width: 10px;
  height: 100%;
  bottom: 0;
  right: -5px;
  cursor: col-resize;
  z-index: 1;
}
</style>